import { App, defineAsyncComponent } from "vue";

const components = {
  BaseSvgIcon: () => import("@/components/control/base-svg-icon.vue"),
  BaseAlert: () => import("@/components/control/base-alert.vue"),
  BaseButton: () => import("@/components/control/base-button.vue"),
  BaseBadge: () => import("@/components/control/base-badge.vue"),
  BaseCheckbox: () => import("@/components/control/base-checkbox.vue"),
  BaseCombobox: () => import("@/components/control/base-combobox.vue"),
  BaseDatePicker: () => import("@/components/control/base-date-picker.vue"),
  BaseDrawer: () => import("@/components/control/base-drawer.vue"),
  BaseDropdown: () => import("@/components/control/base-dropdown.vue"),
  BaseEmpty: () => import("@/components/control/base-empty.vue"),
  BaseInput: () => import("@/components/control/base-input.vue"),
  BaseListBox: () => import("@/components/control/base-list-box.vue"),
  BaseModal: () => import("@/components/control/base-modal.vue"),
  BaseMultiSelect: () => import("@/components/control/base-multi-select.vue"),
  BaseMultiSelectTabs: () =>
    import("@/components/control/base-multiselect-tabs.vue"),
  BasePaginationButtoned: () =>
    import("@/components/control/base-pagination-buttoned.vue"),
  BasePagination: () => import("@/components/control/base-pagination.vue"),
  BaseProgressBar: () => import("@/components/control/base-progress-bar.vue"),
  BaseRadioGroup: () => import("@/components/control/base-radio-group.vue"),
  BaseResult: () => import("@/components/control/base-result.vue"),
  BaseSearch: () => import("@/components/control/base-search.vue"),
  BaseSpinner: () => import("@/components/control/base-spinner.vue"),
  BaseSwitch: () => import("@/components/control/base-switch.vue"),
  BaseTab: () => import("@/components/control/base-tab.vue"),
  BaseTable: () => import("@/components/control/base-table.vue"),
  BaseTextarea: () => import("@/components/control/base-textarea.vue"),
  BaseToggleButton: () => import("@/components/control/base-toggle-button.vue"),
  ConfirmDelete: () => import("@/components/control/confirm-delete.vue"),
  BaseAvatar: () => import("@/components/control/base-avatar.vue"),
  BaseBadges: () => import("@/components/control/base-badges.vue"),
  AddressWithIcon: () =>
    import("@/components/control/tooltip/address-with-icon.vue"),
  KebabButton: () => import("@/components/control/kebabButton.vue"),
  LoadingSkeletonMobile: () =>
    import("@/components/control/loading-skeleton-mobile.vue"),
  LoadingSkeleton: () => import("@/components/control/loading-skeleton.vue"),
  LoadingSkeletonGraph: () =>
    import("@/components/control/loading-skeleton-graph.vue"),
  BaseHeader: () => import("@/components/control/base-header/base-header.vue"),
  BaseSteps: () => import("@/components/control/base-steps.vue"),
  BaseStepper: () => import("@/components/control/base-stepper.vue"),
  BaseTimestamp: () => import("@/components/control/base-timestamp.vue"),
  Tooltip: () => import("@/components/control/tooltip/tooltip.vue"),
  TextWithTooltip: () =>
    import("@/components/control/tooltip/text-with-tooltip.vue"),
  BaseMap: () => import("@/components/control/base-map.vue"),
  ExportOptions: () => import("@/components/control/export-options.vue"),
  BaseStatsCard: () => import("@/components/control/base-stats-card.vue"),
  BaseRecipientAddressAvatar: () =>
    import("@/components/control/base-recipient-address-avatar.vue"),
  BaseColorPicker: () =>
    import("@/components/control/base-color-picker/base-color-picker.vue"),
  DrawerModalAccessibilityWrapper: () =>
    import("@/components/control/drawer-modal-accessibility-wrapper.vue"),
  BaseBatteryIcon: () => import("@/components/control/base-battery-icon.vue"),
};

export const registerComponents = (app: App): void => {
  for (const [name, loader] of Object.entries(components)) {
    app.component(name, defineAsyncComponent(loader as any));
  }
};
